export function buildSearchDomain(
  search: string,
  fields: string[],
  isIntegerField: (field: string) => boolean,
): any[] | null {
  if (!search || fields.length === 0) return null;

  const isSearchNumeric = !Number.isNaN(Number(search));

  const domain: any[] = [];

  const conditions: any[] = [];

  for (const field of fields) {
    if (isIntegerField(field) && isSearchNumeric) {
      conditions.push([field, '=', Number(search)]);
    } else {
      conditions.push([field, 'ilike', search]);
    }
  }

  if (conditions.length === 0) return null;

  if (conditions.length === 1) {
    return [conditions[0]];
  }

  for (let i = 0; i < conditions.length - 1; i++) {
    domain.push('|');
  }

  domain.push(...conditions);

  return domain;
}
